// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__efnZo","label":"Toggle_label__ctN9-","input":"Toggle_input__dcYJg","slider":"Toggle_slider__-B5qH"};